import { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Api from '../../services/ApiService';
import FileService from '../../services/FileService';
import LoadingPage from '../LoadingPage';
import { modal } from '../modal/ModalEmitter';

class ArchiveList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      listing: [],
    };
  }

  componentDidMount() {
    const { location } = this.props;

    this.getListing(location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.getListing(this.props.location.pathname);
    }
  }

  getListing(path = '/') {
    this.setState({ loading: true });

    return Api.get('archive/list', {
      params: {
        path,
      },
    }).then(res => {
      this.setState({ listing: res.data }, this.setState({ loading: false }));
    });
  }

  download(filePath, generation) {
    const newWin = window.open('', '_blank');
    newWin.document.write('Loading...');

    Api.get('archive', {
      params: {
        filePath,
        generation,
      },
    }).then(res => {
      newWin.location.href = FileService.downloadPath(res.data.fileName);
    });
  }

  handleRowClick(row) {
    if (!row.directory) {
      this.download(row.filePath);
    }
  }

  renderVersions(row) {
    const versionList = row.versions.map(version => {
      return (
        <tr>
          <td>{version.generation}</td>
          <td>{version.size}</td>
          <td>{version.timeDeleted}</td>
          <td>
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              onClick={() => {
                this.download(row.filePath, version.generation);
              }}
            >
              Download
            </button>
          </td>
        </tr>
      );
    });

    modal.open('info', {
      title: `Old Versions - ${row.basename}`,
      hidePrint: true,
      message: (
        <>
          <div className="well well-sm">
            <b>{row.filePath}</b>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Version ID</th>
                <th>Size</th>
                <th>Deleted Date</th>
                <th style={{ width: '85px' }} />
              </tr>
            </thead>
            <tbody>{versionList}</tbody>
          </table>
        </>
      ),
    });
  }

  renderPath() {
    const { location } = this.props;

    const crumbs = [];
    const path = location.pathname.replace(/\/$/, '').split('/');

    crumbs.push(<span key={path.join('/')}> &gt; {path.pop() || 'root'}</span>);

    while (path.length) {
      crumbs.unshift(
        <span key={path.join('/')}>
          &nbsp;/&nbsp;
          <Link to={`${path.join('/')}/`}>{path.pop() || 'root'}</Link>
        </span>
      );
    }

    return <div className="crumbs">{crumbs}</div>;
  }

  renderRowDir(row) {
    return (
      <tr key={row.basename}>
        <td>
          <i className="zmdi zmdi-folder zmdi-hc-fw zmdi-hc-lg" />
        </td>
        <td>
          <Link to={row.filePath}>{row.basename}</Link>
        </td>
        <td>-</td>
        <td>-</td>
      </tr>
    );
  }

  renderRowFile(row) {
    const versionButton =
      row.versions && row.versions.length ? (
        <div className="badge badge-primary" onClick={() => this.renderVersions(row)}>
          {row.versions.length}
        </div>
      ) : (
        '-'
      );

    return (
      <tr>
        <td>
          <i className="zmdi zmdi-file-text zmdi-hc-fw zmdi-hc-lg" />
        </td>
        <td>
          <a
            style={{ cursor: 'pointer' }}
            onClick={() => {
              this.handleRowClick(row);
            }}
          >
            {row.basename}
          </a>
        </td>
        <td>{versionButton}</td>
        <td>{row.size}</td>
      </tr>
    );
  }

  renderListing() {
    const { listing, loading } = this.state;

    if (loading) {
      return (
        <tr>
          <td colSpan="3">
            <LoadingPage />
          </td>
        </tr>
      );
    }

    if (!listing || !listing.length) {
      return (
        <tr>
          <td colSpan="3">Directory Empty</td>
        </tr>
      );
    }

    return listing.map(row => (row.directory ? this.renderRowDir(row) : this.renderRowFile(row)));
  }

  render() {
    return (
      <div id="archive-browse" className="container-fluid">
        {this.renderPath()}
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: '15px' }} />
              <th>Name</th>
              <th>Versions</th>
              <th>Bytes</th>
            </tr>
          </thead>
          <tbody>{this.renderListing()}</tbody>
        </table>
      </div>
    );
  }
}

ArchiveList.propTypes = {
  location: PropTypes.object,
};

export default ArchiveList;
